import apiClient, { unwrap } from './client'

export interface SendLog {
  id: number
  client_name: string | null
  template_name: string | null
  sender: string | null
  recipient: string
  subject: string | null
  status: string
  error: string | null
  created_at: string
}

export const sendLogsApi = {
  /** 按发件人（本地邮箱身份）筛选已发送记录；不传 sender 则返回全部 */
  list(sender?: string, limit = 200) {
    const qs = new URLSearchParams()
    if (sender) qs.set('sender', sender)
    qs.set('limit', String(limit))
    return unwrap<SendLog[]>(apiClient.get(`/send-logs?${qs.toString()}`))
  },
}
